export default function Shop() {
    return(
        <>
        This is shop
        </>
    )
}